@use '@lib/assets/styles/main.scss' as *;

.modalContentClassName {
  padding-top: 24px;
}

.root {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 48px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 10px;
  background: $gray10;
  padding: 16px;
}

.nav {
  display: flex;
  gap: 8px;
}

.info {
  display: flex;
  align-items: center;
  gap: 16px;
}

.infoItem {
  display: flex;
  align-items: center;
  gap: 8px;
}

.infoItemSeparator {
  width: 1px;
  height: 24px;
  background: $gray100;
}

.tableWrapper {
  width: 100%;
}

.redRow {
  background-color: $error100 !important;
}

.yellowRow {
  background-color: $warning100 !important;
}
